const EN_ORIGIN = 'https://en.fgqslc.com'
const ZH_ORIGIN = 'https://www.fgqslc.com'
const SITE_NAME = 'FGQ'
const STABLE_ALTERNATE_ROUTES = new Set(['index', 'types', 'afterSale', 'guide', 'news', 'aboutUs', 'contactUs'])

const DEFAULT_SEO = {
  title: 'Electric Tricycle Manufacturer | FGQ',
  description: 'FGQ is an electric tricycle manufacturer offering cargo, passenger, enclosed and sanitation product series for distributors, importers, wholesalers and fleet buyers worldwide.'
}

const ROUTE_SEO = {
  index: DEFAULT_SEO,
  types: {
    title: 'Electric Tricycle Products and Models | FGQ',
    description: 'Browse FGQ leisure, passenger, electric cargo, enclosed, sanitation and special-purpose tricycle product series from FGQ.'
  },
  aboutUs: {
    title: 'About the Electric Tricycle Manufacturer | FGQ',
    description: 'Learn about FGQ, an electric tricycle manufacturer in Guanghan, Sichuan, China, and its product development and support focus.'
  },
  contactUs: {
    title: 'Contact Electric Tricycle Manufacturer | FGQ',
    description: 'Contact FGQ for electric tricycle product information and international business enquiries, including Hong Kong, Macao and Taiwan.'
  },
  news: {
    title: 'Company and Product News | FGQ',
    description: 'Read electric tricycle product, company and service updates from FGQ.'
  },
  afterSale: {
    title: 'Product Support and After-sales Information | FGQ',
    description: 'Find electric tricycle product support and after-sales information provided by FGQ.'
  },
  guide: {
    title: 'Electric Tricycle Use and Maintenance Guide | FGQ',
    description: 'Read electric tricycle use, maintenance and parts warranty information from FGQ.'
  },
  show: {
    title: 'FGQ Electric Tricycle Product Information',
    description: 'View FGQ electric tricycle product, technology, service and company information.'
  },
  newdetail: {
    title: 'FGQ News Article | FGQ',
    description: 'Read a company or electric tricycle product update from FGQ.'
  },
  jobIndex: {
    title: 'Careers at FGQ',
    description: 'View career information and current opportunities at FGQ.'
  },
  jobList: {
    title: 'Current Job Openings | FGQ',
    description: 'Browse current job openings at FGQ.'
  },
  jobInfo: {
    title: 'Job Details | FGQ',
    description: 'Review details for a current role at FGQ.'
  },
  Job: {
    title: 'Careers at FGQ',
    description: 'Explore career information from FGQ.',
    robots: 'noindex,follow'
  },
  getjob: {
    title: 'Job Application | FGQ',
    description: 'Submit a job application to FGQ.',
    robots: 'noindex,nofollow'
  },
  feadback: {
    title: 'Website Feedback | FGQ',
    description: 'Send website feedback to FGQ.',
    robots: 'noindex,nofollow'
  },
  notfound: {
    title: 'Page Not Found | FGQ',
    description: 'The requested page could not be found.',
    robots: 'noindex,nofollow'
  }
}

function upsertMeta(selector, attributes, content) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]))
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function upsertLink(hreflang, href) {
  const selector = hreflang
    ? `link[rel="alternate"][hreflang="${hreflang}"]`
    : 'link[rel="canonical"]'
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', hreflang ? 'alternate' : 'canonical')
    if (hreflang) element.setAttribute('hreflang', hreflang)
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

function removeAlternateLinks() {
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(element => element.remove())
}

function cleanText(value) {
  return String(value || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function canonicalPath(route) {
  if (!route) return '/'
  const query = new URLSearchParams()
  if (route.name === 'show') {
    if (route.query.id !== undefined) query.set('id', route.query.id)
    if (route.query.op !== undefined) query.set('op', route.query.op)
  } else if (route.name === 'newdetail' || route.name === 'jobInfo') {
    if (route.query.id !== undefined) query.set('id', route.query.id)
  }
  const suffix = query.toString()
  return `${route.path || '/'}${suffix ? `?${suffix}` : ''}`
}

function organizationSchema() {
  return {
    '@type': 'Organization',
    '@id': `${EN_ORIGIN}/#organization`,
    name: 'FGQ',
    url: `${EN_ORIGIN}/`,
    description: 'Electric tricycle manufacturer serving international product enquiries.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Hanzhou Industrial Park, Hanzhou Subdistrict',
      addressLocality: 'Guanghan',
      addressRegion: 'Sichuan',
      addressCountry: 'CN'
    }
  }
}

function websiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': `${EN_ORIGIN}/#website`,
    url: `${EN_ORIGIN}/`,
    name: SITE_NAME,
    inLanguage: 'en',
    publisher: { '@id': `${EN_ORIGIN}/#organization` }
  }
}

function breadcrumbSchema(title, path) {
  if (path === '/') return null
  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${EN_ORIGIN}/` },
      { '@type': 'ListItem', position: 2, name: title.replace(/\s*\|.*$/, ''), item: `${EN_ORIGIN}${path}` }
    ]
  }
}

export function applySeo({ title, description, path, robots, image, type = 'website', schemas = [], includeAlternates = false }) {
  const safeTitle = cleanText(title) || DEFAULT_SEO.title
  const safeDescription = cleanText(description).slice(0, 170) || DEFAULT_SEO.description
  const safePath = path || '/'
  const englishUrl = `${EN_ORIGIN}${safePath}`
  const chineseUrl = `${ZH_ORIGIN}${safePath}`

  document.documentElement.setAttribute('lang', 'en')
  document.title = safeTitle
  upsertMeta('meta[name="description"]', { name: 'description' }, safeDescription)
  upsertMeta('meta[name="robots"]', { name: 'robots' }, robots || 'index,follow,max-image-preview:large')
  upsertMeta('meta[property="og:type"]', { property: 'og:type' }, type)
  upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name' }, SITE_NAME)
  upsertMeta('meta[property="og:title"]', { property: 'og:title' }, safeTitle)
  upsertMeta('meta[property="og:description"]', { property: 'og:description' }, safeDescription)
  upsertMeta('meta[property="og:url"]', { property: 'og:url' }, englishUrl)
  const oldImage = document.head.querySelector('meta[property="og:image"]')
  if (image) {
    upsertMeta('meta[property="og:image"]', { property: 'og:image' }, image)
  } else if (oldImage) {
    oldImage.remove()
  }

  upsertLink(null, englishUrl)
  if (includeAlternates) {
    upsertLink('en', englishUrl)
    upsertLink('zh-CN', chineseUrl)
    upsertLink('x-default', englishUrl)
  } else {
    removeAlternateLinks()
  }

  const graph = [organizationSchema(), websiteSchema()]
  const breadcrumb = breadcrumbSchema(safeTitle, safePath)
  if (breadcrumb) graph.push(breadcrumb)
  graph.push(...schemas.filter(Boolean))
  let schemaElement = document.head.querySelector('script[data-fgq-seo="structured-data"]')
  if (!schemaElement) {
    schemaElement = document.createElement('script')
    schemaElement.type = 'application/ld+json'
    schemaElement.dataset.fgqSeo = 'structured-data'
    document.head.appendChild(schemaElement)
  }
  schemaElement.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph })
}

export function applyRouteSeo(route) {
  const settings = ROUTE_SEO[route.name] || DEFAULT_SEO
  applySeo({
    ...settings,
    path: canonicalPath(route),
    includeAlternates: STABLE_ALTERNATE_ROUTES.has(route.name)
  })
}

export function applyProductSeo({ route, name, category, image }) {
  const path = canonicalPath(route)
  const productName = cleanText(name)
  const categoryName = cleanText(category)
  if (!productName) return applyRouteSeo(route)
  const description = `Explore ${productName} in the ${categoryName || 'FGQ product range'}, including available product images and color presentations from FGQ.`
  applySeo({
    title: `${productName}${categoryName ? ` | ${categoryName}` : ''} | FGQ`,
    description,
    path,
    image,
    type: 'product',
    schemas: [{
      '@type': 'Product',
      name: productName,
      image: image ? [image] : undefined,
      category: categoryName || undefined,
      brand: { '@type': 'Brand', name: 'FGQ' },
      manufacturer: { '@id': `${EN_ORIGIN}/#organization` },
      url: `${EN_ORIGIN}${path}`
    }]
  })
}

export function applyArticleSeo({ route, title, content }) {
  const articleTitle = cleanText(title)
  if (!articleTitle) return applyRouteSeo(route)
  const summary = cleanText(content).slice(0, 160) || `Read ${articleTitle} from FGQ.`
  applySeo({
    title: `${articleTitle} | FGQ News`,
    description: summary,
    path: canonicalPath(route),
    type: 'article'
  })
}
